import { API_URL } from '../../../app-config/constants';
import type { BILLING_LOCATION } from '../../../types/CustomerDto';
import type PlanDto from '../../../types/PlanDto';
import { get } from '../request';

// -- End user facing -- //

export namespace Customer {
    const BASE_URL = `${API_URL}/your-billing`;

    getAll.operation = 'READ';
    export function getAll(): Promise<PlanDto[]> {
        return get<PlanDto[]>(`${BASE_URL}/plans`);
    }
}

// -- Company Observer facing -- //

export namespace CompanyObserver {
    const CO_BASE_URL = `${API_URL}/billing`;

    getAll.operation = 'READ';
    export function getAll(companyId: string): Promise<PlanDto[]> {
        return get<PlanDto[]>(`${CO_BASE_URL}/${companyId}/plans`);
    }

    getAll.operation = 'READ';
    export function getForLocation(location: BILLING_LOCATION): Promise<PlanDto[]> {
        return get<PlanDto[]>(`${CO_BASE_URL}/plans?location=${location}`);
    }
}
